<template>
    <div class="payment-term" style="position: relative">
        <compWrapper title="基本信息" theme="primary">
            <Form
                ref="myForm"
                class="padding-15"
                :model="formData"
                :labelWidth="160"
            >
                <FormItem
                    label="Apply for"
                    prop="applyType"
                    :rules="type != 'query' ? required : {}"
                >
                    <CheckboxGroup
                        v-if="type == 'query'"
                        v-model="formData.applyType"
                    >
                        <!-- <Checkbox label="VENDOR" disabled>Vendor</Checkbox>
                        <Checkbox label="CUSTOMER" disabled>Customer</Checkbox> -->
                        <Checkbox
                            v-for="item in getApplyType"
                            :key="item.value"
                            :label="item.value"
                            disabled
                            >{{ item.enLabel }}</Checkbox
                        >
                    </CheckboxGroup>
                    <CheckboxGroup v-else v-model="formData.applyType">
                        <!-- <Checkbox label="VENDOR">Vendor</Checkbox>
                        <Checkbox label="Customer">Customer</Checkbox> -->
                        <!-- <Checkbox label="Forwarder"></Checkbox> -->
                        <Checkbox
                            v-for="item in getApplyType"
                            :key="item.value"
                            :label="item.value"
                            >{{ item.enLabel }}</Checkbox
                        >
                    </CheckboxGroup>
                </FormItem>
                <FormItem
                    label="Payment Name"
                    prop="paymentName"
                    :rules="type == 'add' ? required : {}"
                >
                    <div class="font-bold" v-if="type != 'add'">
                        {{ formData.paymentName }}
                    </div>
                    <Input v-else v-model="formData.paymentName" />
                </FormItem>
                <FormItem label="Payment Term Description">
                    <div class="font-bold" v-if="type == 'query'">
                        {{ formData.paymentDescription }}
                    </div>
                    <Input v-else v-model="formData.paymentDescription" />
                </FormItem>
                <FormItem v-if="type == 'query'" label="Status">
                    <div class="font-bold">
                        {{ formData.status == 1 ? "启用" : "停用" }}
                    </div>
                </FormItem>
            </Form>
        </compWrapper>
        <compWrapper title="明细" theme="info">
            <div class="padding-15 data-table">
                <div>
                    <Table
                        border
                        :columns="queryColumns"
                        :data="dataList"
                        size="small"
                    ></Table>
                </div>
            </div>
        </compWrapper>
        <compWrapper title="操作历史" theme="gray">
            <Table
                class="margin-15"
                border
                :columns="logColumns"
                :data="logDataList"
                size="small"
            ></Table>
        </compWrapper>
        <compModal
            v-model="operate.show"
            v-bind="operate"
            @on-confirm="confirm"
            :closable="false"
        >
            <component
                v-if="operate.component"
                :is="operate.component"
                v-bind="operate"
                v-on="operate.on"
                @on-closeCloseable="closeCloseable"
                @on-openCloseable="openCloseable"
                @on-close="operate = {}"
            />
        </compModal>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpGetPaymentDetail,
    HttpGetLogData,
} from "@/service/purchase/purchase";
export default {
    props: ["querytype", "params"],
    data() {
        return {
            type: this.querytype ? this.querytype : this.$route.params.type,
            id: this.params ? this.params : this.$route.query.id,
            formData: {},
            dataList: [
                {
                    id: Symbol(null),
                    prepayFlag: 0,
                    percentage: null,
                },
                {
                    id: Symbol(null),
                    prepayFlag: 0,
                    percentage: null,
                },
            ],
            chooseId: 0,
            logDataList: [],
            sendDataList: [],
            totalPercent: 0,
            operate: {
                show: false,
            },
            loading: false,
        };
    },
    async created() {
        console.log(this.type, this.id);
        if (this.type == "query") {
            this.dataList = [];
        }
        if (this.type != "add") {
            this.loading = true;
            await this.getDetail();
            await this.getLogData();
            this.loading = false;
        }
    },
    computed: {
        getApplyType() {
            return [
                {
                    label: "供应商",
                    enLabel: "Vendor",
                    value: "0",
                },
                {
                    label: "客户",
                    enLabel: "Customer",
                    value: "1",
                },
            ];
        },
        getStatusType() {
            return [
                {
                    label: "启用",
                    value: 1,
                },
                {
                    label: "停用",
                    value: 0,
                },
            ];
        },
        required() {
            return [
                {
                    required: true,
                    message: "此项不能为空",
                },
            ];
        },
        queryColumns() {
            return [
                {
                    title: "Seq",
                    type: "index",
                },
                {
                    title: "Prepay",
                    key: "prepayFlag",
                    render: (h, { row }) => {
                        let label = row.prepayFlag == 0 ? "No" : "Yes";
                        return <div>{label}</div>;
                    },
                },
                {
                    title: "Due:Percentage",
                    key: "percentage",
                },
                {
                    title: "Baseline Date Field",
                    key: "dateField",
                },
                {
                    title: "Due: Days",
                    key: "payDays",
                },
                {
                    title: "Due: Date",
                    key: "payTime",
                },
                {
                    title: "Due: Day of Month",
                    key: "payDate",
                },
                {
                    title: "Discount(%)",
                    key: "discount",
                },
            ];
        },
        logColumns() {
            return [
                {
                    title: "时间",
                    key: "opAt",
                },
                {
                    title: "操作人",
                    key: "createdName",
                },
                {
                    title: "操作内容",
                    key: "opRemark",
                    render: (h, { row }) => {
                        let operateName = this.getLogTypeList.filter((item) => {
                            return item.value == row.opAction;
                        })[0];
                        return (
                            <div>
                                <div>操作类型：{operateName.label || "--"}</div>
                                <div>操作内容：{row.opRemark}</div>
                            </div>
                        );
                    },
                },
            ];
        },
        getLogTypeList() {
            return [
                {
                    value: "create",
                    label: "创建",
                },
                {
                    value: "submit",
                    label: "提交",
                },
                {
                    value: "reject",
                    label: "驳回",
                },
                {
                    value: "audit",
                    label: "审核",
                },
                {
                    value: "void",
                    label: "作废",
                },
                {
                    value: "writeoff",
                    label: "核销",
                },
                {
                    value: "finish",
                    label: "完成",
                },
                {
                    value: "update",
                    label: "更新",
                },
                {
                    value: "complete",
                    label: "手动完成",
                },
                {
                    value: "delete",
                    label: "删除",
                },
                {
                    value: "status",
                    label: "状态",
                },
            ];
        },
    },
    methods: {
        async getDetail() {
            await HttpGetPaymentDetail({
                id: this.id,
            }).then(
                (res) => {
                    let { items, ...formData } = { ...res.data };
                    this.formData = formData;
                    this.formData.applyType =
                        this.formData.applyType.split(",");
                    this.dataList = items;
                    let chooseItem = this.dataList.filter((item) => {
                        return item.prepayFlag == 1;
                    })[0];
                    this.chooseId = chooseItem ? chooseItem.id : 0;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async getLogData() {
            await HttpGetLogData({
                opModel: "FinancePaymentTermHeader",
                id: this.id,
            }).then(
                (res) => {
                    console.log("log", res);
                    this.logDataList = res.data;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
    },
};
</script>

<style>
</style>